// extracted by mini-css-extract-plugin
var _1 = "FileAttachTagStatuses-modulestatuses__ZCLzI";
export { _1 as "statuses" }
